// 租户后台现货返佣仅使用简体中文。
export default {
  "unsupportedMode": "现货仅支持不返佣或自动返佣＋日返，请核对返佣模式和周期，本次未保存。",
  "rate": "现货返佣比例",
  "mode": "现货返佣模式",
  "disabled": "不返佣",
  "daily": "自动日返（次日19点）",
  "loadError": "现货设置加载失败，请重新查询。",
  "reload": "重新加载",
  "requery": "关闭并重新查询",
  "notReady": "请先查询并核对该合伙人的现货设置，本次未保存。",
  "integer": "现货返佣比例须为0～100的整数。",
  "saved": "合约及现货设置保存成功。",
  "contractFailed": "合约设置保存失败，现货设置未提交，请检查后重试。",
  "contractUnknown": "合约设置保存结果未确认，现货设置未提交，请关闭弹窗并重新查询核对。",
  "spotFailed": "合约设置已保存，现货设置保存失败，请检查上下级比例和模式后重试。",
  "spotUnknown": "合约设置已保存，现货设置保存结果未确认，请关闭弹窗并重新查询核对。"
}
